export const baseURL = 'https://gwapi.newhopedairy.cn/admin/api/'
export const KLineURL = 'https://gwapi.newhopedairy.cn/'

//设置session存 储
const ss = window.sessionStorage;
export const  SStorage = {
  getItem(key) {
    try {
      return JSON.parse(ss.getItem(key))
    } catch (err) {
      return null
    }
  },
  setItem(key, val) {
    ss.setItem(key, JSON.stringify(val))
  },
  clear() {
    ss.clear()
  },
  keys() {
    return ss.keys()
  },
  removeItem(key) {
    ss.removeItem(key)
  }
};

//设置locale存储
const ll = window.localStorage;
export const  LLtorage = {
  getItem(key) {
    try {
      return JSON.parse(ll.getItem(key))
    } catch (err) {
      return null
    }
  },
  setItem(key, val) {
    ll.setItem(key, JSON.stringify(val))
  },
  clear() {
    ll.clear()
  },
  keys() {
    return ll.keys()
  },
  removeItem(key) {
    ll.removeItem(key)
  }
};

//获取uuid
export function getUuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  return s.join("");
}

//保留两位小数
export function toFix(num){
  var result = parseFloat(num);

  result = Math.round(num * 100) / 100;
  var s_x = result.toString(); //将数字转换为字符串

  var pos_decimal = s_x.indexOf('.'); //小数点的索引值

  // 当整数时，pos_decimal=-1 自动补0
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += '.';
  }

  // 当数字的长度< 小数点索引+2时，补0
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0';
  }
  return s_x;
}





// WEBPACK FOOTER //
// ./src/api/common.js